import { GET_CLIENT_METADATA } from "hooks/useClientMetadata"

export function buildVendorRecord(id, name, attrs = {}) {
  return {
    type: "vendors",
    id: id,
    attributes: {
      name: name,
      ...attrs
    },
  }
}

export function buildClientRecord(id, name, relationships = {}) {
  return {
    type: "clients",
    id: id,
    attributes: {
      name: name,
    },
    relationships: {
      ...relationships,
    }
  }
}

export function buildContractRecord(clientId, vendorId) {
  return {
    type: "contracts",
    id: `${clientId}-${vendorId}`,
    relationships: {
      client: { data: { type: 'clients', id: clientId } },
      vendor: { data: { type: 'vendors', id: vendorId } },
    }
  }
}

export function buildProgramGroupRecord(id, description, clientId) {
  return {
    type: "program-groups",
    id: id,
    attributes: {
      description: description,
    },
    relationships: {
      client: { data: { type: 'clients', id: clientId } },
    }
  }
}

export function buildClientCampaignRecord(id, name, contractId, programGroupId, attrs = {}) {
  return {
    type: "client-campaigns",
    id: id,
    attributes: {
      name: name,
      status: 'active',
      ...attrs
    },
    relationships: {
      contract: { data: { type: 'contracts', id: contractId } },
      programGroup: { data: { type: 'program-groups', id: programGroupId } },
    }
  }
}

export function buildClientRoleRecord(id, clientId, attrs = {}) {
  return {
    id: id,
    type: "client-roles",
    attributes: {
      name: "Test Role",
      ...attrs
    },
    relationships: {
      users: { data: [{ id: "me", type: "users" }] },
      client: { data: { id: clientId, type: "clients" }}
    }
  }
}

export function mockGetClientMetadata({ clientIds = [], statuses = [], dispositions = [], customAttributeDefinitions = [] }: { clientIds?: string[], statuses?: unknown[], dispositions?: unknown[], customAttributeDefinitions?: unknown[] } = {}) {
  return {
    request: {
      query: GET_CLIENT_METADATA,
      variables: {
        ids: clientIds,
      },
    },
    result: {
      data: {
        clients: [
          {
            __typename: 'Client',
            metadata: {
              statuses,
              dispositions,
            },
            customAttributeDefinitions,
          },
        ],
      },
    },
  }
}
